import * as images from "@/components/images/Images";
import type { AboutUsHeroData } from "./types";
import { ROUTES } from "@/constants";

export const aboutUsHeroData = {
  title: "Languex is language excellence",
  description:
    "We’re on a mission to help global businesses grow by getting the most accurate, high-quality human translations to market faster,without friction.",
  imageUrl: images.aboutUsHero,
  imageDimensions: {
    width: 802,
    height: 858,
  },
} as AboutUsHeroData;
